import { render } from "./CategoriesTable.vue?vue&type=template&id=f36cb18a&scoped=true&ts=true"
import script from "./CategoriesTable.vue?vue&type=script&lang=ts"
export * from "./CategoriesTable.vue?vue&type=script&lang=ts"

import "./CategoriesTable.vue?vue&type=style&index=0&id=f36cb18a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36cb18a"]])

export default __exports__